//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import ProjectSelct from "../components/projectSelct";
import { formatDate } from '../../../src/lib/date';
import util from '@/lib/util';
import CertificateBox from "../components/certificateBox";

export default {
    name: "home",
    components: {
        CertificateBox,
        ProjectSelct,
        BottomNav,
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            hotActive: [],
            images: [
                require('@/assets/img/banner-index1.jpg'),
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg'
            ],
            icons: [
                {
                    image: require('@/assets/img/index-ico1.png'),
                    // image: require('@/assets/img/iconNew-01.png'),
                    text: '工程进度',
                    path: '/selectCity'
                },
                {
                    image: require('@/assets/img/index-ico2.png'),
                    // image: require('@/assets/img/iconNew-02.png'),
                    text: '交付预约',
                    path: '/order'
                },
                {
                    image: require('@/assets/img/index-ico3.png'),
                    // image: require('@/assets/img/iconNew-03.png'),
                    text: '工程报修',
                    path: '/repair'
                },
                {
                    image: require('@/assets/img/index-ico4.png'),
                    // image: require('@/assets/img/iconNew-04.png'),
                    text: '投诉咨询',
                    path: '/suggest'
                },
                {
                    image: require('@/assets/img/index-ico5.png'),
                    // image: require('@/assets/img/iconNew-05.png'),
                    text: '联系客服',
                    path: '/serviceCustom'
                },
                {
                    image: require('@/assets/img/index-ico6.png'),
                    // image: require('@/assets/img/iconNew-06.png'),
                    text: '产证查询',
                    path: '/cert-houses'
                },
                {
                    image: require('@/assets/img/index-ico7.png'),
                    // image: require('@/assets/img/iconNew-07.png'),
                    text: '微楼书',
                    path: '/projectSale'
                },
                {
                    image: require('@/assets/img/index-ico8.png'),
                    // image: require('@/assets/img/iconNew-08.png'),
                    text: '生日福利',
                    path: '/welfareNotice'
                },
                {
                    image: require('@/assets/img/index-ico9.png'),
                    // image: require('@/assets/img/iconNew-09.png'),
                    text: '问卷调查',
                    path: '/question'
                },
                {
                    image: require('@/assets/img/index-ico10.png'),
                    // image: require('@/assets/img/iconNew-10.png'),
                    text: '我买网',
                    path: '/'
                },
            ],
            activeHot: [
                {
                    id: '0',
                    hotImage: require('@/assets/img/activ-img1.jpg'),
                    activeTitle: '圣诞礼品大派送，小区业主享“福”拉~圣诞礼品大派送，小区业主享“福”拉~',
                    activeStartTime: '2019/12/24',
                    activePrice: '免费'
                },
                {
                    id: '1',
                    hotImage: require('@/assets/img/activ-img2.jpg'),
                    activeTitle: '家门口的育苗行动，快领着你们的小可爱一起参加吧',
                    activeStartTime: '2019/12/24',
                    activePrice: '免费'
                },
            ],
            hotActivities: [],
            downloadUrl: util.ApiUrl + 'file/download/',
            contents: [],
            hotGoods: [],
            isShowCert: false,
            member: {}
        }
    },
    methods: {
        getHotActive() {
            // console.log('----------------');
            var page = {
                memberId: this.member.id,
                memberLevel: this.member.memberLevel,
                maxResultCount: 2,
                skipCount: 0
            }
            // console.log(page);
            abp.ajax.post('/api/services/app/Activity/Search', page).then((res) => {
                this.hotActivities = res.data.result.items;
                /*window.console.log(this.hotActive)*/
            });
        },
        // 轮播图预览
        Preview_img(images, index) {
            ImagePreview({
                images: images,//图片数组
                showIndex: true,
                loop: false,
                startPosition: index
            })
        },
        async getMyMember() {
            var vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
                if (vm.member.lastProjectId > 0) {
                    localStorage.setItem('Select-ProjectId', vm.member.lastProjectId);
                }
                localStorage.setItem('MemberId', vm.member.id);
                this.getHotActive();
            });
        },
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetContentByNodeName?name=' + '首页广告').then((res) => {
                this.contents = [];
                this.contents.push(...res.data.result);
                // console.log(this.contents)
            });
        },
        showActivityDetail(id) {
            this.$router.push('/activeDetail/' + id);
        },
        onSwipeClicked(content) {
            if (content.contentType === 0) {
                this.$router.push('/contentDetail/' + content.id);
            } else if (content.contentType === 1 && content.source != null) {
                if (content.source.startsWith('http')) {
                    // if (content.source.substr(0, 4) === 'http') {
                    window.open(content.source);
                } else {
                    window.open('http://' + content.source);
                }
            } else {
                // this.$router.push('/contentDetail/' + content.id);
            }

        },
        getHotGoods() {
            var page = {
                maxResultCount: 2,
                skipCount: 0
            };
            // this.loading = true;
            abp.ajax.post('/api/services/app/Good/SearchHotGoods', page).then(res => {
                this.hotGoods = [];
                this.hotGoods.push(...res.data.result.items);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        },
        goodInfo(id) {
            this.$router.push({ path: '/productDetail/' + id })
        },
        onGridClicked(name) {
            if (JSON.stringify(this.member) === '{}') {
                return;
            }

            if (name === '/welfareNotice' || name === '/deliverOrder' || name === '/repair' || name === '/suggest' || name === '/cert-houses' || name === '/order') {
                // this.member.isOwner = false;
                if (this.member.isAuthentication) {
                    // console.log(this.isShowCert);
                    this.$router.push(name);
                } else {
                    this.isShowCert = true;
                    return;
                }
            } else if (name === '/') {
                /*this.$router.push(name);*/
                window.location.href = 'https://www.womai.com/index-31000-0.htm';
            } else {
                this.$router.push(name);
            }
        },
        certificate() {
            this.$router.push({ path: '/character' })
        },

        reload() {
            window.location.reload()//重新加载
        }
    },
    created() {
        // this.login();
        this.getMyMember();
        this.getContentByNodeName();
        // this.getHotActive();
        this.getHotGoods();
    },

    activated() {
        //在页面中创建一个 history 实体,当实体改变时会触发popstate事件，跳转到当前页面，并重新加载当前页面
        window.history.pushState(null, 'ff', document.URL);
        window.addEventListener('popstate', this.reload, true)
    },

    //本来在deactivated中写移除事件监听的，但是发现不能移除，可能这个生命周期是在路由跳转完(keep-alive缓存的组件停用时调用)从而找不到那个this了，所以移除监听失败。
    deactivated() {
        window.removeEventListener('popstate', this.reload, true)
    },

    //所以采用组件内的路由守卫beforeRouteLeave,成功解决了移除监听事件。
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        window.removeEventListener('popstate', this.reload, true) //这个一定要写到next()前面
        next()
    }
}
